import React from 'react'
import styled from 'styled-components'

import PasswordShowSrc from '../../../../../manager/images/pw-show.svg'

const PasswordShow = styled.img`
    height: 22.5px;
    width: 22.5px;
    position: center;
    vertical-align: middle;
    `
const PasswordShowIcon = () => (
    <PasswordShow src={PasswordShowSrc} />
)

export default PasswordShowIcon
